//libs
import { styled } from '@nykaa/ui-components';

//mixin
import { truncate } from 'shared/styles/mixin';

export const List = styled.div<{
  isLeftAligned: boolean;
  isDisabled: boolean;
  isSelected: boolean;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 1;

  ${({ isSelected, theme }) =>
    !isSelected &&
    `&:hover {
    background-color: ${theme.colors.filterHover};
  }`};

  ${({ isLeftAligned, theme }) =>
    isLeftAligned
      ? `width: 256px;
      padding: ${theme.spacing.spacing40} ${theme.spacing.spacing40};`
      : `flex-direction: row-reverse;
      justify-content: space-between;
      width: auto;
      padding: ${theme.spacing.spacing50} ${theme.spacing.spacing50} ${theme.spacing.spacing50} ${theme.spacing.spacing80};
    `};
  ${({ isDisabled }) =>
    isDisabled &&
    `opacity: 0.2;
    transition: 400ms opacity ease-in-out;
    `};
  ${({ isSelected, theme }) =>
    isSelected && `background-color: ${theme.colors.filterSelected}`};

  svg circle {
    fill: ${({ theme }) => theme.colors.surface};
  }
  
`;

export const OptionName = styled.div<{ isSelected: boolean; }>`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};
  ${({ isSelected, theme }) => isSelected && theme.typography.subTitleMedium};
  ${truncate}
`;

export const OptionCount = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: ${({ theme }) => `${theme.spacing.spacing0} ${theme.spacing.spacing40}`};
  padding-top: ${({ theme }) => theme.spacing.spacing10};
  ${({ theme }) => theme.typography.bodySmall};
  align-self: center;
`;

export const ValueContainer = styled.div<{ isLeftAligned: boolean; }>`
  display: flex;
  ${truncate}
  ${({ isLeftAligned, theme }) => isLeftAligned && `margin-left: ${theme.spacing.spacing60}`};
  margin-right: ${({ theme }) => `${theme.spacing.spacing160}`};
`;
